import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ValueAccessor, setBkkrClasses } from './value-accessor';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'bkkr-checkbox,bkkr-toggle',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: BooleanValueAccessorDirective,
      multi: true,
    },
  ],
})
export class BooleanValueAccessorDirective extends ValueAccessor {
  constructor(injector: Injector, el: ElementRef) {
    super(injector, el);
  }

  writeValue(value: any): void {
    this.el.nativeElement.checked = this.lastValue = value == null ? false : value;
    setBkkrClasses(this.el);
  }

  @HostListener('bkkrChange', ['$event.target'])
  _handlebkkrChange(el: any): void {
    this.handleChangeEvent(el, el.checked);
  }
}
